import {GenericWalletAdapter} from '@/model/wallets/adapters/GenericWalletAdapter'
import {WalletAdapterContext} from '@/store/modules/WalletAdapterModule'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {$} from '@/facade'
import {PopulateSdkStatusParams} from '@/model/wallets/types/WalletTypes'
import {InvocationBuilderResult} from '@/model/wallets/invocationsBuilder/N3InvocationBuilder'
import {
  SdkNotInitializedError,
  RejectedByUser,
  BadInvocationRequest,
} from '@/model/wallets/types/WalletErrors'

export class NeolineAdapter implements GenericWalletAdapter {
  platform: WalletPlatform = WalletPlatform.NEOLINE
  address: string | null = null
  private sdkN3: any = null

  async init(onDelete: () => void): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof window === 'undefined') {
        reject(SdkNotInitializedError(WalletPlatform.NEOLINE))
        return
      }

      const timeout = setTimeout(() => {
        reject(SdkNotInitializedError(WalletPlatform.NEOLINE))
      }, 10000)

      window.addEventListener('NEOLine.N3.EVENT.READY', () => {
        try {
          clearTimeout(timeout)

          const neoLineN3 = (window as any).NEOLineN3
          if (typeof neoLineN3 === 'undefined') {
            reject(SdkNotInitializedError(WalletPlatform.NEOLINE))
            return
          }

          this.sdkN3 = new neoLineN3.Init()
          resolve()
        } catch {
          reject(SdkNotInitializedError(WalletPlatform.NEOLINE))
        }
      })

      window.addEventListener('NEOLine.NEO.EVENT.ACCOUNT_CHANGED', () => {
        onDelete()
        this.address = null
      })
    })
  }

  async connect() {
    if (!this.sdkN3) throw SdkNotInitializedError(WalletPlatform.NEOLINE)

    this.address = (await this.sdkN3.getAccount()).address

    // Neoline doesn't have support to this
    return {
      approval: async () => {},
      uri: '',
    }
  }

  getAddress(): string {
    if (!this.address) throw new Error('No address found')

    return this.address
  }

  async disconnect(): Promise<void> {
    this.address = null
  }

  isInstalled(): boolean {
    return typeof (window as any).NEOLineN3 !== 'undefined' && this.sdkN3
  }

  async invoke(params: any): Promise<string> {
    if (!this.sdkN3) throw SdkNotInitializedError(WalletPlatform.NEOLINE)

    try {
      const invokeOutput = await this.sdkN3.invokeMultiple(params)

      if (!invokeOutput && !invokeOutput.txid) {
        throw BadInvocationRequest
      }

      return invokeOutput.txid
    } catch (e) {
      console.error(e)
    }

    return ''
  }
}
